import { useParams, useSearchParams } from 'react-router-dom';

import { AppUpdateCategoryPage } from '~/components/pages/AppUpdateCategoryPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { useNavigate } from '~/components/utils/Navigation';

export const AppUpdateCategoryRoute: React.FC = () => {
  const { appId, categoryId } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  if (!appId || !categoryId) {
    navigate('/');

    return null;
  }

  return (
    <DashboardTemplate appId={appId}>
      <AppUpdateCategoryPage
        appId={appId}
        categoryId={categoryId}
        nextUrl={searchParams.get('nextUrl') ?? undefined}
        cancelUrl={searchParams.get('cancelUrl') ?? undefined}
      />
    </DashboardTemplate>
  );
};
